/* eslint no-console: 0 */
/* global axios */
import ApiClient from '../ApiClient';

class LazadaAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getVouchers(params) {
    return axios.get(`${this.url}/${params.conversationID}/lazada/vouchers`);
  }

  getOrders(params) {
    return axios.get(`${this.url}/${params.conversationID}/lazada/orders`, {
      params: {
        order_status: params.orderStatus,
      },
    });
  }

  searchProducts(conversationID, keyword) {
    return axios.get(`${this.url}/${conversationID}/lazada/products`, {
      params: { keyword },
    });
  }

  sendOrder(conversationID, orderID) {
    return axios.post(`${this.url}/${conversationID}/lazada/send_order`, {
      order_id: orderID,
    });
  }

  sendProduct(conversationID, itemID) {
    return axios.post(`${this.url}/${conversationID}/lazada/send_product`, {
      item_id: itemID,
    });
  }

  sendVoucher(conversationID, voucherId, voucherCode) {
    return axios.post(`${this.url}/${conversationID}/lazada/send_voucher`, {
      voucher_id: voucherId,
      voucher_code: voucherCode,
    });
  }
}

export default new LazadaAPI();
